import Vue from 'vue'
import App from './App.vue'
import { store } from '@/store.js'
import './user.js'
import router from './router.js'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

Vue.config.productionTip = false

Vue.use(Antd)

store.dispatch("fetchUserInfo");

const id = (new URLSearchParams(window.location.search)).get('id');
export const loadHook = store.dispatch("$user/fetchUserInfo", { id });

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')